import script from "./MoneyHubCallbackPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MoneyHubCallbackPage.vue?vue&type=script&setup=true&lang=ts"

import "./MoneyHubCallbackPage.vue?vue&type=style&index=0&id=70b203ac&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70b203ac"]])

export default __exports__